import { customAlphabet } from 'nanoid';

const elIdNanoId = customAlphabet('abcdefghijklmnopqrstuvwxyzABCDEFGJIJKLMNOPQRSTUVWXYZ')

/**
 * 生成随机DOM id
 */
export function randomElId(len = 10) {
  return elIdNanoId(len)
}
